import React from 'react';
import { Grid, Box, Skeleton, Typography } from '@mui/material';
import AppCard from './AppCard';

function AppCardGrid({ apps, selectedIds, lockedIds, onToggle, loading }) {
  // Skeleton di caricamento
  if (loading) {
    return (
      <Grid container spacing={2}>
        {Array.from({ length: 8 }).map((_, i) => (
          <Grid item xs={12} sm={6} md={4} lg={3} key={i}>
            <Box sx={{ borderRadius: 3, overflow: 'hidden' }}>
              <Skeleton variant="rectangular" height={200} sx={{ borderRadius: 3 }} />
            </Box>
          </Grid>
        ))}
      </Grid>
    );
  }

  if (!apps || apps.length === 0) {
    return (
      <Box sx={{ textAlign: 'center', py: 4 }}>
        <Typography variant="body1" color="text.secondary">
          Nessuna applicazione trovata
        </Typography>
      </Box>
    );
  }

  return (
    <Grid container spacing={2}>
      {apps.map(app => (
        <Grid item xs={12} sm={6} md={4} lg={3} key={app.id}>
          <AppCard
            app={app}
            selected={selectedIds.has(app.id) || lockedIds.has(app.id)}
            locked={lockedIds.has(app.id)}
            onToggle={onToggle}
          />
        </Grid>
      ))}
    </Grid>
  );
}

export default AppCardGrid;
